import { gql } from '@apollo/client';

export const sendInvitationToPreRegistrant_Name = 'SendInvitationToPreRegistrant';
export const sendInvitationToPreRegistrant_Gql = gql`
  mutation SendInvitationToPreRegistrant($preRegistrantId: String!) {
    sendInvitationToPreRegistrant(preRegistrantId: $preRegistrantId)
  }
`;
